import { z } from "zod";

export const ContractTypeSchema = z.object({
    title: z.string(),
    shortTitle: z.string(),
    shortTitlePlural: z.string(),
    icon: z.string(),
    sectorIds: z.array(z.number()),
    filePrefix: z.string(),
});

export type ContractType = z.infer<typeof ContractTypeSchema>;